import { useState } from "react";
import AssignmentSchedule from "./partials/AssignmentSchedule";
import ProctoringSelect from "./partials/ProctoringSelect";
import QuestionSelection from "./partials/QuestionSelection";
import CustomQuestionModal from "./partials/CustomQuestionModal";

const StepFour = () => {
  const [isModalOpen, setModalOpen] = useState("");
  return (
    <div className="flex flex-col overflow-y-auto h-2/3 text-sm xl:text-base">
      <AssignmentSchedule />
      <ProctoringSelect />
      <QuestionSelection openModal={() => setModalOpen("open")} />
      <CustomQuestionModal
        isModalOpen={isModalOpen}
        setModalOpen={setModalOpen}
      />
    </div>
  );
};

export default StepFour;
